import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { Container, theme, useNavbarContainerHeight, useResponsive } from '@sg/garnish';

import { AccountMenu, PageWrapper } from '../../components';
import { AccountScreenHeader } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountScreenContent = () => {
  const { currentBreakpoint, minWidth } = useResponsive();
  const { paddingTopStyle: navbarPaddingTopStyle } = useNavbarContainerHeight();

  // ─── Flags ───────────────────────────────────────────────────────────

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldRenderScreenHeader = currentBreakpoint.isXS;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const menuContainerStyles = minWidth.isSM ? navbarPaddingTopStyle : undefined;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      {shouldRenderScreenHeader ? <AccountScreenHeader /> : null}

      <PageWrapper
        style={styles.pageWrapper}
        safeAreaEdges={shouldRenderScreenHeader ? [] : ['top']}
        safeAreaViewStyle={accountSafeAreaViewStyle}
      >
        <Container style={menuContainerStyles}>
          <AccountMenu />
        </Container>
      </PageWrapper>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
  pageWrapper: {
    flex: 1,
    backgroundColor: theme.colors.APP_BACKGROUND,
  },
  contentContainer: {
    paddingVertical: theme.spacing['4'],
  },
  safeAreaView: {
    maxHeight: undefined, // overrides default style
  },
});

const accountSafeAreaViewStyle = Platform.select({ native: styles.safeAreaView });
